<section class="summary-data-table-component">
  <div class="row py-3 mx-0 d-flex justify-content-between">
    <!-- View For / Any other dropdown select section -->
    <div class="col-12 col-md-3 px-0" *ngIf="options.contentSelector">
      <div class="content-selector-panel">
        {{ data.contentSelector.label }} &nbsp;&nbsp;
        <select [value]="data.contentSelector?.selectedValue" (change)="data.contentSelector.onChange($event)">
          <option
            *ngFor="let option of data.contentSelector?.selectionOptions"
            [value]="option.key"
            [selected]="option.key == data.contentSelector?.selectedValue">
            {{ option.value }}
          </option>
        </select>
      </div>
    </div>

    <!-- Download / Export Buttons Section -->
    <div
      class="col-12 col-md-7 px-0 text-md-end download-options ms-auto"
      [ngClass]="{ 'col-md-10': !options.contentSelector }">
      <a class="download-as-label" *ngIf="options.downloadable">Download as</a>
      <a (click)="data?.downloadDocumentCallback('CSV')" class="download-button" *ngIf="options.downloadable"
        ><img src="assets/images/svg/xls.svg" />&nbsp; CSV</a
      >
      <a (click)="data?.downloadDocumentCallback('XLSX')" class="download-button" *ngIf="options.downloadable"
        ><img src="assets/images/svg/xls.svg" />&nbsp; XLS</a
      >
      <a (click)="data?.downloadDocumentCallback('PDF')" class="download-button" *ngIf="options.downloadable"
        ><img src="assets/images/svg/pdf.svg" />&nbsp; PDF</a
      >
      <span *ngIf="options.additionalButtons">
        <ng-container *ngFor="let button of data.additionalButtons">
          <a
            *ngIf="(button.actionType || 'route') === 'route'"
            [id]="button.id"
            class="additional-button"
            [routerLink]="button.route">
            {{ button.label }}
          </a>
          <a
            *ngIf="button.actionType === 'download'"
            [id]="button.id"
            class="download-button"
            (click)="button.callback(button.downloadType)">
            {{ button.label }}
          </a>
        </ng-container>
      </span>
    </div>
  </div>

  <div *ngIf="options.quickFilters" class="row py-3 mx-0">
    <div class="col px-0">
      <a *ngFor="let button of data.quickFilters" class="filter-btn" (click)="handleFilter(button)">{{
        button.label
      }}</a>
      <a class="filter-btn" (click)="handleFilter(resetButton)">Reset Filters</a>
    </div>
  </div>

  <!-- Data Table Section -->
  <div class="summary-table col-12 overflow-auto">
    <form [formGroup]="summarySearchForm">
      <table
        class="table table-striped table-bordered table-sm row-border hover"
        *ngIf="data.content$ | async as dataRecords">
        <thead (submit)="searchFormSubmit()" (change)="searchFormSubmit()" (keyup.enter)="searchFormSubmit()">
          <tr class="column-header-row">
            <th style="width: 40px" class="selection-cell"></th>
            <th style="max-width: 150px; overflow-x: hidden; word-wrap: break-word" *ngFor="let header of data.headers">
              {{ header.name }}<br />
              <div *ngIf="header?.filter?.showIncludeAndExclude" class="d-flex gap-2 justify-content-center pt-1">
                <label>
                  <input type="radio" id="include" value="true" [formControlName]="header.filter.key + '.isInclude'" />
                  Include
                </label>
                <label>
                  <input type="radio" id="exclude" value="false" [formControlName]="header.filter.key + '.isInclude'" />
                  Exclude
                </label>
              </div>
              <div class="sort-icons" *ngIf="header.sortByKey">
                <a
                  [ngClass]="
                    data.currentSearchParams.sortBy == header.key && data.currentSearchParams.sortOrder == 'ASC'
                      ? 'selected'
                      : ''
                  "
                  (click)="data.sortCallback(header.sortByKey, 'ASC')">
                  <i class="fa fa-caret-down"></i>
                </a>
                <a
                  [ngClass]="
                    data.currentSearchParams.sortBy == header.key && data.currentSearchParams.sortOrder == 'DESC'
                      ? 'selected'
                      : ''
                  "
                  (click)="data.sortCallback(header.sortByKey, 'DESC')">
                  <i class="fa fa-caret-up"></i>
                </a>
              </div>
            </th>
            <th *ngIf="options.actionsColumn" class="actions-column-header">Actions</th>
          </tr>
          <tr>
            <th *ngIf="options.contentSelectable">
              <input
                type="checkbox"
                name="select-all"
                id="select-all"
                value=""
                (click)="toggleSelectAll($event, dataRecords.content)" />
            </th>

            <!-- Search Filter Input Elements Row -->
            <th *ngFor="let header of data.headers">
              <div *ngIf="header.filter">
                <input
                  *ngIf="header.filter.type == FieldType.TEXT"
                  type="text"
                  class="search_text"
                  id="search_{{ header.filter.key }}"
                  [formControlName]="header.filter.key" />
                <select
                  *ngIf="header.filter.type == FieldType.SELECT"
                  class="search_text"
                  id="search_{{ header.filter.key }}"
                  [formControlName]="header.filter.key">
                  <option></option>
                  <option
                    *ngFor="let option of header.filter?.getOptionsList('ACTIVITY') | keyvalue"
                    [value]="option.key">
                    {{ option.value }}
                  </option>
                </select>
                <select
                  *ngIf="header.filter.type == FieldType.SELECT_TASK_STATUS"
                  class="search_text"
                  id="search_{{ header.filter.key }}"
                  [formControlName]="header.filter.key">
                  <option></option>
                  <option *ngFor="let option of header?.filter?.getOptionsList() | keyvalue" [value]="option.key">
                    {{ option.value }}
                  </option>
                </select>
                <input
                  *ngIf="header.filter.type == FieldType.DATE"
                  type="date"
                  class="form-control"
                  onFocus="this.showPicker()"
                  [formControlName]="header.filter.key"
                  (input)="validateDateInput($event, header)"
                  onclick="this.showPicker()"
                  onkeydown="return false" />
                <ng-container *ngIf="header.filter.type == FieldType.TEXT_AUTOCOMPLETE">
                  <input
                    type="text"
                    placeholder=""
                    [matAutocomplete]="auto"
                    class="search_text"
                    id="search_{{ header.filter.key }}"
                    [formControlName]="header.filter.key" />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    [displayWith]="displayFn.bind(this)"
                    (optionSelected)="onSelect($event.option.value, header.filter.key)">
                    <mat-option
                      *ngFor="let employee of employees"
                      [value]="employee?.id"
                      (mousedown)="onOptionMouseDown()">
                      {{ employee?.employeeCode }}
                    </mat-option>
                  </mat-autocomplete>
                </ng-container>
                <ng-container *ngIf="header.filter.type == FieldType.MULTISELECT">
                  <tag-input
                    [placeholder]="header.filter?.placeholder || 'Enter To Search'"
                    [secondaryPlaceholder]="header.filter?.placeholder || 'Enter To Search'"
                    [formControlName]="header.filter.key"
                    (onAdd)="this.searchFormSubmit()"
                    (onRemove)="searchFormSubmit()">
                    <tag-input-dropdown
                      [autocompleteItems]="transformOptionList(header?.filter?.getOptionsList())"
                      [showDropdownIfEmpty]="true"
                      [dynamicUpdate]="false">
                    </tag-input-dropdown>
                  </tag-input>
                </ng-container>
                <app-validation
                  [field]="header.filter.key"
                  [form]="summarySearchForm"
                  [error]="createValidationErrorMessages(header)"></app-validation>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr [class]="data.rowFormatting && data.rowFormatting(record)" *ngFor="let record of dataRecords.content">
            <td *ngIf="options.contentSelectable" class="selection-cell rowColor">
              <input
                type="checkbox"
                [name]="record['id']"
                [checked]="data.checkBoxSelectionIds?.indexOf(record.id) >= 0"
                (click)="onCheckBoxChecked($event, record)" />
            </td>
            <td
              *ngFor="let header of data.headers"
              class="rowFormatting"
              [ngClass]="header.cssClasses ? header.cssClasses : ''">
              <a *ngIf="header.anchor" [routerLink]="header.anchor.link(record)">
                {{ header.build(record) }}
              </a>
              <span *ngIf="!header.anchor" (click)="header?.onClick?.(record)">
                {{ header.build(record) }}
              </span>
            </td>
            <td *ngIf="options.actionsColumn" class="actions-column">
              <div class="actions-container">
                <div class="dropdown">
                  <button
                    class="btn btn-link"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-offset="0,10"
                    (click)="toggleDropdown($event)">
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end action-menu" aria-labelledby="dropdownMenuButton">
                    <ng-container *ngFor="let action of options.actionsColumn?.actions">
                      <li *ngIf="action.showCondition?.(record)" [ngClass]="action.cssClass">
                        <a class="dropdown-item" (click)="action.callback(record)">
                          <ng-container *ngIf="action.icon; else actionName">
                            <i [class]="action.icon"></i>
                          </ng-container>
                          <ng-template #actionName>{{ action.name }}</ng-template>
                        </a>
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="dataRecords?.totalElements === 0">
            <td class="no-rows-to-display" [attr.colspan]="100">No Records Found</td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
  <div class="col-12 pagination" *ngIf="data.content$ | async as dataRecords">
    <div *ngIf="this.data?.onDropdownLimitChange" class="col-1 limit-dropdown-container">
      <select [value]="selectedLimitDropdownValue" (change)="onLimitValueChange($event?.target?.value)">
        <option
          *ngFor="let limit of limitDropdownValues"
          [value]="limit"
          [selected]="limit == selectedLimitDropdownValue">
          {{ limit }}
        </option>
      </select>
    </div>
    <div class="col-5 showing">
      Showing {{ dataRecords.size * dataRecords.number + 1 }} to
      {{
        dataRecords.number == dataRecords.totalPages - 1
          ? dataRecords.totalElements
          : dataRecords.size * (dataRecords.number + 1)
      }}
      of {{ dataRecords.totalElements }} records
    </div>
    <div class="col-6">
      <ul class="col-12 text-md-end">
        <li *ngIf="dataRecords.number != 0">
          <div class="inverse" (click)="data.selectPageCallback(dataRecords.number - 1)">
            <i class="fas fa-angle-left"></i>
          </div>
        </li>

        <ng-container *ngFor="let page of [].constructor(dataRecords.totalPages); let i = index">
          <li *ngIf="!(i > dataRecords.number + 5) && !(i < dataRecords.number - 5)">
            <div [class]="dataRecords.number == i ? 'selected' : ''" (click)="data.selectPageCallback(i)">
              {{ i + 1 }}
            </div>
          </li>
        </ng-container>

        <li *ngIf="dataRecords.number != dataRecords.totalPages - 1">
          <div class="inverse" (click)="data.selectPageCallback(dataRecords.number + 1)">
            <i class="fas fa-angle-right"></i>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="col-12 formatting-legend">
    <div>
      <ul>
        <li *ngFor="let formatting of data.formattingLegend">
          <div [class]="formatting.formatClassName"></div>
          {{ formatting.formatLabel }}
        </li>
      </ul>
    </div>
  </div>
</section>
